import { create } from "zustand";

interface LoadingIndicatorStore {
  loading: boolean;
  setLoading: (loading: boolean) => void;
}

export const useLoadingIndicatorStore = create<LoadingIndicatorStore>(
  (set) => ({
    loading: false,
    setLoading: (loading: boolean) => {
      set({ loading });
    },
  })
);
